// extracted by mini-css-extract-plugin
module.exports = {"slideWrapper":"ImageSlider_slideWrapper__i8qPX","topPadding":"ImageSlider_topPadding__BWkvD"};